import * as actionTypes from './action-types'

export const fetchNotifications = () => ({
  type: actionTypes.FETCH,
})

export const removeAllNotifications = () => ({
  type: actionTypes.REMOVE_ALL,
})

export const removeNotification = id => ({
  type: actionTypes.REMOVE,
  payload: { id },
})

export const readAllNotifications = () => ({
  type: actionTypes.READ_ALL,
})

export const markNotification = (id, viewed) => ({
  type: actionTypes.MARK,
  payload: { id, viewed },
})

export const setNotificationsCount = count => ({
  type: actionTypes.SET_COUNT,
  payload: count,
})

export const clearNotifications = () => ({
  type: actionTypes.CLEAR_DATA,
})

export const fakeReactAllNotifications = () => ({
  type: actionTypes.FAKE_READ_ALL,
})
